<app-generic-table
  id="wallet-fav-table"
  [data]="favorites"
  [config]="tableConfig"
  [isLoading]="isLoading"
  [page]="page"
  [pageSize]="perPage"
  [totalRegisters]="totalRegisters"
  [noDataMessage]="noDataMessage"
  (pageChange)="changePage($event)"
  >
  <!-- Icon Column -->
  <ng-template appTableCell="_icon" let-favorite>
    <img
      id="wallet-fav-img-icon-{{favorite.id}}"
      [src]="getFavoriteIcon()"
      alt="Favorite icon"
      style="max-width: 30px"
      />
    </ng-template>

    <!-- Name Column -->
    <ng-template appTableCell="name" let-favorite>
      <a
        id="wallet-fav-link-name-{{favorite.id}}"
        mat-menu-item
        class="link-name"
        (click)="selectedOptionNavbarRedirect(favorite)"
        >
        {{ favorite.name }}
      </a>
    </ng-template>

    <!-- Actions Column -->
    <ng-template appTableCell="_actions" let-favorite>
      <div class="action-column">
        <a
          id="wallet-fav-btn-delete-{{favorite.id}}"
          (click)="handleDelete(favorite)"
          [ngClass]="{ inactive: favorite.base }"
          matTooltip="Excluir Carteira"
          i18n-matTooltip="@@deleteWallet"
          matTooltipClass="custom-tooltip"
          >
          <em class="far fa-trash-alt"></em>
        </a>
        @if (!favorite.isAlert30Days) {
          <a
            id="wallet-fav-btn-edit-{{favorite.id}}"
            (click)="handleEdit(favorite)"
            [ngClass]="{ inactive: favorite.base }"
            matTooltip="Editar Carteira"
            i18n-matTooltip="@@editWallet"
            matTooltipClass="custom-tooltip"
            >
            <em class="fas fa-pencil-alt"></em>
          </a>
        }
        <a
          id="wallet-fav-btn-toggle-{{favorite.id}}"
          (click)="toggleFavorite(favorite)"
          matTooltip="Remover dos Favoritos"
          i18n-matTooltip="@@removeFavorites"
          matTooltipClass="custom-tooltip"
          >
          <em [class]="favorite.favorite ? 'fas fa-star' : 'far fa-star'"></em>
        </a>
        <a
          id="wallet-fav-btn-alerts-{{favorite.id}}"
          (click)="manageAlerts(favorite)"
          matTooltip="Gerenciar Alertas e Notificações"
          i18n-matTooltip="@@manageAlerts"
          matTooltipClass="custom-tooltip"
          >
          <em class="far fa-bell"></em>
        </a>
      </div>
    </ng-template>
  </app-generic-table>
